export const APPLY_LOCATION = "APPLY_LOCATION";